import { ActionTypes } from "../constants";

const reduceAppraisees = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_RMS_APPRAISEES_SUCCESS:
            return action.data || [];

        case ActionTypes.GET_RMS_APPRAISEES_FAILURE:
            return [];

        case ActionTypes.GET_RMS_APPRAISEE_SUCCESS:
            return [
                ...(state || []).filter(
                    ({ uuid }) => uuid !== action.payload.uuid
                ),
                action.data,
            ];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export const getAppraisee = (appraisees, appraiseeUUID) =>
    !appraisees ? null : appraisees.find(({ uuid }) => uuid === appraiseeUUID);

export default reduceAppraisees;
